import React from "react";
import Navbar from './Navbar';
import AboutMe from "./AboutMe";
import Footer from "./Footer";

const About = () => {
    return (
        <>
            <Navbar />
            <AboutMe />
            <Footer />
        </>
    );
}

export default About;